<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="goBack">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Diário online - Professor auxiliar
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <div class="d-flex mb-2 justify-space-between">
          <v-btn
            color="success"
            @click="criarGestaoDeAula"
            class="mr-2"
            v-show="$can(['gestoesDeAulas.criar', 'gestoesDeAulas.*'])"
            >Criar Vínculo</v-btn
          >
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>
        </div>
      </v-col>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="gestoesDeAulasList"
          :loading="carregandoGestoesDeAulas"
          :items-per-page="10"
          hide-default-footer
          no-data-text="Não foram encontrádos vínculos para você, por favor entre em contato com a secretaria/coordenação para que lhe adicionem acesso às turmas e disciplinas"
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="200">
              <tr
                color="primary"
                :class="gestaoDeAulas.estaDeletado ? ['deleted'] : []"
                v-for="gestaoDeAulas of items"
                :key="gestaoDeAulas.id"
              >
                <td>{{ gestaoDeAulas.id }}</td>
                <td width="25%">
                  {{ gestaoDeAulas.matricula ? gestaoDeAulas.matricula.nomecompleto : "- - -" }}
                </td>
                <td>{{ gestaoDeAulas.nomeTurma ? gestaoDeAulas.nomeTurma : "- - -" }}</td>
                <td class="text-left">
                  <e-resumo-disciplinas
                    :items="
                      gestaoDeAulas.disciplinas_vinculo ? gestaoDeAulas.disciplinas_vinculo : []
                    "
                  />
                </td>
                <td width="25%">
                  {{ gestaoDeAulas.nomeProfessor ? gestaoDeAulas.nomeProfessor : "- - -" }}
                </td>
                <!-- <td>{{ gestaoDeAulas.contexto }}</td> -->
                <td>
                  <div class="text-center">
                    <e-acoes-auxiliares-2026
                      v-if="usarMenuNovo"
                      :gestao-de-aulas="gestaoDeAulas"
                      @editar="editarGestaoDeAula"
                      @deletar="deletarGestaoDeAula"
                      @lancar-pei="abrirModalPei('lancar', gestaoDeAulas)"
                      @baixar-pei="abrirModalPei('baixar', gestaoDeAulas)"
                    />
                    <e-acoes-auxiliares-legado
                      v-else
                      :gestao-de-aulas="gestaoDeAulas"
                      @editar="editarGestaoDeAula"
                      @deletar="deletarGestaoDeAula"
                      @gerar-relatorio="modalRelatorio"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="listarGestoesDeAulas"
          :search="search"
        ></e-paginate>
        <!-- eslint-disable  -->
        <v-dialog v-model="dialog" persistent width="500">
          <v-card>
            <v-card-title class="text-h6 primary white--text"> Escolha um disciplina </v-card-title>
            <e-autocomplete
              class="mx-2 mt-2"
              :items="disciplinas"
              :return-object="false"
              :item-value="(value) => value.id"
              :item-text="(value) => value.descricao"
              v-model="disciplina_id"
              label="Selecione uma disciplina"
            />

            <e-autocomplete
              class="mx-2"
              :items="meses"
              return-object
              :item-value="(value) => value.id"
              :item-text="(value) => value.descricao"
              v-model="selectMonth"
              label="Selecione um mes"
            />

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="dialog = !dialog"> Fechar </v-btn>
              <v-btn color="primary" text @click="gerarRelatorio"> Gerar relatório </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- PEI: de 2026 em diante (#7286). Lançar e baixar pedem o bimestre. -->
        <v-dialog v-model="dialogPei" persistent width="500">
          <v-card>
            <v-card-title class="text-h6 primary white--text">
              {{ acaoPei === "baixar" ? "Baixar P.E.I" : "Lançar PEI" }}
            </v-card-title>

            <e-autocomplete
              id="select-bimestre-pei"
              class="mx-2 mt-4"
              :items="bimestres"
              :return-object="false"
              :item-value="(value) => value.value"
              :item-text="(value) => value.desc"
              v-model="bimestrePei"
              label="Selecione o bimestre"
            />

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn id="btn-fechar-modal-pei" color="red" text @click="dialogPei = false">
                Fechar
              </v-btn>
              <v-btn
                id="btn-confirmar-modal-pei"
                color="primary"
                text
                :disabled="bimestrePei === null"
                @click="confirmarModalPei"
              >
                {{ acaoPei === "baixar" ? "Baixar" : "Continuar" }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import GestaoDeAula from "@/Models/GestaoDeAula";

export default {
  computed: {
    ...mapGetters("Auth", ["user"]),
    /**
     * Menu Ações novo só de 2026 em diante (#7286, Cenário 16). Anos anteriores
     * continuam no componente legado, com o comportamento que sempre tiveram.
     */
    usarMenuNovo() {
      const ano = Number(this.user?.ano?.descricao);
      if (!ano) return false;
      return ano >= this.$constants.anoInicioDiarioAuxiliaresNovo;
    },
    bimestres() {
      return this.$constants.bimestres;
    },
  },
  data() {
    return {
      search: "",
      dialogPei: false,
      acaoPei: null,
      gestaoPei: null,
      bimestrePei: null,
      gestoesDeAulasList: [],
      pageNumber: 0,
      carregandoGestoesDeAulas: false,
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Aluno", value: "nomeFranquia" },
          { text: "Turma", value: "nomeTurma" },
          { text: "Disciplina", value: "nomeDisciplina" },
          { text: "Professor", value: "nomeProfessor" },
          { text: "", value: "actions", sortable: false, width: "200px" },
        ],
      },
      disciplinas: [],
      gestao_id: null,
      disciplina_id: null,
      dialog: false,
      meses: [],
      selectMonth: {
        id: 2,
        descricao: "Fevereiro",
      },
    };
  },
  async mounted() {
    this.load();
  },
  watch: {
    carregandoGestoesDeAulas(value) {
      if (value && this.gestoesDeAulasList.length === 0) {
        this.$loaderService.open("Carregando gestoesDeAulas");
      } else {
        this.$loaderService.close();
      }
    },
    async search(val) {
      if (val.length > 2) {
        await this.listarGestoesDeAulas(0, val);
      }
      if (!val) {
        await this.listarGestoesDeAulas(0);
      }
    },
  },
  methods: {
    goBack() {
      if (this.user.role.name.includes("prof")) {
        // this.$router.push({ name: "acessoProfessor.home" });
        this.$router.go(-1);
      }
      this.$router.push({ name: "home" });
    },
    async listarGestoesDeAulas(pageNumber, query = null) {
      this.carregandoGestoesDeAulas = true;
      try {
        const response = await this.$services.gestoesDeAulasAuxiliaresService.syncAll(
          pageNumber,
          query
        );
        this.gestoesDeAulasList = await response.data.map((gestao) => new GestaoDeAula(gestao));
        this.paginate = response;
      } catch {
        this.carregandoGestoesDeAulas = false;
      }
      this.carregandoGestoesDeAulas = false;
    },
    criarGestaoDeAula() {
      this.$router.push({ name: "gestoesDeAulasAuxiliares.newEdit" });
    },
    async editarGestaoDeAula(gestaoDeAulas) {
      this.$router.push({
        name: "gestoesDeAulasAuxiliares.edit",
        params: { gestaoDeAulasId: gestaoDeAulas.id },
      });
    },
    async deletarGestaoDeAula(gestaoDeAulas) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar esta gestaoDeAulas?",
        confirmationCode: gestaoDeAulas.id,
        confirmationMessage: `Por favor, digite <strong>${gestaoDeAulas.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando a GestaoDeAula");
              try {
                await this.$services.gestoesDeAulasAuxiliaresService.deletarGestaoDeAula(
                  gestaoDeAulas
                );
                this.$toast.success("GestaoDeAula deletada com sucesso");
                this.$forceUpdate();
                this.load();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
    // PEI: de 2026 em diante (#7286). Lançar e baixar precisam do bimestre.
    abrirModalPei(acao, gestao) {
      this.acaoPei = acao;
      this.gestaoPei = gestao;
      this.bimestrePei = null;
      this.dialogPei = true;
    },
    async confirmarModalPei() {
      const gestaoId = this.gestaoPei.id;
      const bimestre = this.bimestrePei;
      this.dialogPei = false;

      if (this.acaoPei === "lancar") {
        this.$router.push({
          name: "peis.lancar",
          params: { gestaoId, bimestre },
        });
        return;
      }

      this.$loaderService.open("Gerando o PEI...");
      try {
        await this.$services.peisService.baixarPdf(gestaoId, bimestre);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async modalRelatorio(gestao) {
      this.disciplinas = gestao.disciplinas_vinculo;
      this.gestao_id = gestao.id;
      this.dialog = !this.dialog;
    },
    async gerarRelatorio() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioAuxiliar(
          this.gestao_id,
          this.disciplina_id,
          this.selectMonth.id
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async load() {
      try {
        this.$loaderService.open("Carregando gestoesDeAulas");
        await this.listarGestoesDeAulas(this.pageNumber);
        this.meses = await this.$services.anosService.meses();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style></style>
